import { Link } from 'react-router-dom';

interface ComicCardProps {
  slug: string;
  title: string;
  author: string;
  cover: string;
  rating: number;
  views: number;
  chapters: number;
  status: string;
  tags: string[];
  category: string;
}

export default function ComicCard({
  slug,
  title,
  author,
  cover,
  rating,
  views,
  chapters,
  status,
  tags,
}: ComicCardProps) {
  return (
    <Link
      to={`/comic/${slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute top-2 left-2">
          <span className="inline-block bg-[oklch(var(--accent-500))] text-[oklch(var(--background-50))] text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="inline-flex items-center gap-1 bg-black/40 text-white text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
            <i className="ri-star-fill text-[oklch(var(--accent-500))] text-[10px]" />
            {rating}
          </span>
        </div>
        <div className="absolute bottom-2 left-2 right-2">
          <div className="flex items-center justify-between text-white text-xs">
            <span className="whitespace-nowrap">
              <i className="ri-eye-line mr-1" />
              {views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views}
            </span>
            <span className="whitespace-nowrap">共{chapters}话</span>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-[oklch(var(--foreground-950))] group-hover:text-[oklch(var(--primary-500))] transition-colors truncate">
        {title}
      </h3>
      <p className="text-xs text-[oklch(var(--foreground-600))] mt-1 truncate">{author}</p>
      <div className="flex flex-wrap gap-1 mt-2">
        {tags.slice(0, 3).map((tag) => (
          <span
            key={tag}
            className="inline-block text-[10px] text-[oklch(var(--secondary-700))] bg-[oklch(var(--secondary-100))] px-1.5 py-0.5 rounded whitespace-nowrap"
          >
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}